module.exports = __webpack_public_path__ + "static/innovation_imgM@2x-76e00a45dd0bf15231db59c531da6c72.png";